import { useLazyQuery, useQuery, useMutation } from "@apollo/client/react"; import React, { useState, useEffect, useMemo } from 'react';

import { useDebounce } from '../../../../src/hooks/useDebounce';
import { RenderInputByTypeMobile } from '../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { adaptInsumosArray, GET_INSUMOS_VALIDATE_RI } from '../../../data/graphQL/queries/Insumos/queries';
import { CREATE_INDICACION_BAP } from '../../../data/graphQL/mutations/ResumenIngresoValidation/CreateEvaluacionBAP';
import { Autocomplete, Box, TextField, Grid, InputAdornment, CircularProgress } from '@mui/material';
import { adaptIndicacionesArray, GET_INDICATIONS_BY_EVALUACION } from '../../../data/graphQL/queries/ResumenIngresoValidation/getIndicacionesByEvaluacion';
import { GET_ALIMENTACION_PARENTERAL_CONTRATO, adaptAlimentacionParenteralContrato } from '../../../data/graphQL/queries/Contratos/EvaluacionAsistencial/getAlimentacionParenteralContrato';
import toast from 'react-hot-toast';
import SearchIcon from '@mui/icons-material/Search';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { getStringQueryCombosRI } from '../../../data/graphQL/queries/ResumenIngreso/getAllCombosRI';
import { adaptCombosRIArray } from '../../../adapters/resumenIngreso/combosRIAdapter';

export const IndicacionesBAP = ({ idEvaluacion, idTipoModulo, setChildrenAction, readOnly, setCountIndicaciones }) => {
  const [indicacionesBAP, setIndicacionesBAP] = useState({});
  const [indicacion, setIndicacion] = useState({});
  const [combosRI, setCombosRI] = useState();

  const handleChange = (name, value) => {
    setIndicacionesBAP((indicaciones) => ({
      ...indicaciones,
      [name]: value
    }));
  };

  const handleEsquemas = (data) => {
    setIndicacionesBAP((indicaciones) => ({
      ...indicaciones,
      ['volumenMagistral']: data?.volumenMagistral,
      ['idComboRIValorModoInfusion']: data?.idComboRIValorModoInfusion,
      ['idComboRIValorSelladoCateter']: data?.idComboRIValorSelladoCateter,
      ['diasConexionSemanaMagistral']: data?.diaConexionRIMagistral,
      ['diasConexionSemana']: data?.diaConexionRIEstandar,
      ['magistral']: !!data?.diaConexionRIMagistral,
      ['bAPestandar']: !!data?.diaConexionRIEstandar
    }));
  };

  const handleSelectInsumo = (newValue) => {
    handleChange('idInsumo', newValue.id);
    setNombreInsumoSelected(newValue.label);
  };

  const [getEsquemas, { loading: esquemaLoading }] = useLazyQuery(GET_ALIMENTACION_PARENTERAL_CONTRATO, {
    fetchPolicy: 'no-cache',

  });

  useEffect(() => {
    if (!idEvaluacion) return;
    getEsquemas({ variables: { idEvaluacion } }).
      then((res) => {
        const auxData = adaptAlimentacionParenteralContrato(res?.data);
        handleEsquemas(auxData);
        updateCountIndicaciones(auxData.diaConexionRIMagistral, auxData.diaConexionRIEstandar);
      });
  }, [idEvaluacion]);

  const { refetch: refetchIndicaciones, data: indicacionesData } = useQuery(GET_INDICATIONS_BY_EVALUACION, {
    fetchPolicy: 'no-cache',
    variables: { idEvaluacion },
  });

  useEffect(() => {
    if (!indicacionesData) return;

    const auxArray = adaptIndicacionesArray(indicacionesData);
    const auxData = auxArray.length > 0 ? auxArray[0] : {};
    setIndicacion(auxData);
    handleChange('cantidadDiaria', auxData?.cantidadDiaria);
    handleChange('idInsumo', auxData?.idInsumo);
  }, [indicacionesData]);

  const [createIndicacion, { loading: indicacionLoading }] = useMutation(CREATE_INDICACION_BAP, {
    fetchPolicy: 'no-cache'
  });

  const onSubmit = async () => {
    try {
      await createIndicacion({
        variables: {
          idEvaluacion: idEvaluacion,
          input: {
            idInsumo: !!indicacionesBAP?.idInsumo ? indicacionesBAP?.idInsumo : null,
            idTipoModulo: idTipoModulo,
            idComboRiSellado: idTipoModulo == 14 ? null : indicacionesBAP.idComboRIValorSelladoCateter,
            idComboRiInfusion: idTipoModulo == 14 ? null : indicacionesBAP.idComboRIValorModoInfusion,
            volumenMagistral: parseFloat(indicacionesBAP.volumenMagistral),
            cantidadDiaria: parseFloat(indicacionesBAP.cantidadDiaria),
            diasMagistral: indicacionesBAP?.diasConexionSemanaMagistral,
            diasEstandar: indicacionesBAP?.diasConexionSemana
          }
        }
      });
      const { data: indicacionesData } = await refetchIndicaciones();
      updateCountIndicaciones(indicacionesBAP?.diasConexionSemanaMagistral, indicacionesBAP?.diasConexionSemana);
      toast.success('Indicación cargada con éxito');
    } catch (err) {
      toast.error('Ocurrió un error al cargar la indicación');
    }
  };

  const updateCountIndicaciones = (magistral, estandar) => {
    let count = 0;
    if (magistral != null) {
      count = 1;
    }

    if (estandar != null) {
      count += 1;
    }
    setCountIndicaciones(count);
  };

  const inputCombos = inputs.filter((input) => !!input.comboName);

  const { data: combosData } = useQuery(getStringQueryCombosRI(inputCombos));

  useEffect(() => {
    if (!combosData) return;

    setCombosRI(adaptCombosRIArray(combosData));
  }, [combosData]);

  const [
    insumos,
    nombreInsumoSelected,
    filterStatus,
    insumosLoading,
    setFilterStatus,
    setNombreInsumoSelected] =
    useGetInsumos(indicacionesBAP?.idInsumo, indicacion?.nombreInsumo, idEvaluacion);

  const parsedInputs = useMemo(() => {

    if (!combosRI) return inputs;

    return inputs.map((input) => {
      if (!!input.comboName) {
        input.options = combosRI[input.name];
      }
      switch (input.name) {
        case 'volumenMagistral':
          input.required = !!indicacionesBAP.magistral;
          input.disabled = !indicacionesBAP.magistral;
          if (input.disabled) handleChange(input.name);
          break;
        case 'diasConexionSemanaMagistral':
          input.required = !!indicacionesBAP.magistral;
          input.options = input.options.map((o) => ({ ...o, disabled: indicacionesBAP.diasConexionSemana?.includes(o.value) }));
          input.disabled = !indicacionesBAP.magistral;
          if (input.disabled) handleChange(input.name);
          break;
        case 'idInsumo':
          input.required = !!indicacionesBAP.bAPestandar;
          input.disabled = !indicacionesBAP.bAPestandar;
          if (input.disabled) {
            handleChange(input.name);
            setFilterStatus('');
          }
          break;
        case 'cantidadDiaria':
          input.required = !!indicacionesBAP.bAPestandar;
          input.disabled = !indicacionesBAP.bAPestandar;
          if (input.disabled) handleChange(input.name);
          break;
        case 'diasConexionSemana':
          input.required = !!indicacionesBAP.bAPestandar;
          input.options = input.options.map((o) => ({ ...o, disabled: indicacionesBAP.diasConexionSemanaMagistral?.includes(o.value) }));
          input.disabled = !indicacionesBAP.bAPestandar;
          if (input.disabled) handleChange(input.name);
          break;
        case 'idComboRIValorModoInfusion':
          input.required = idTipoModulo !== 14;
          input.hidden = idTipoModulo === 14;
          break;
        case 'idComboRIValorSelladoCateter':
          input.required = idTipoModulo !== 14;
          input.hidden = idTipoModulo === 14;
          break;
        default:
          break;
      }
      if (readOnly) {
        input.disabled = true;
      }
      return input;
    });
  }, [
    combosRI,
    indicacionesBAP.magistral,
    indicacionesBAP.bAPestandar,
    indicacionesBAP.idInsumo,
    indicacionesBAP.diasConexionSemanaMagistral,
    indicacionesBAP.diasConexionSemana,
    esquemaLoading]
  );

  return (
    <Grid container>
      {parsedInputs?.filter((input) => !input.hidden).map((input, index) => {

        return <>
          {
            input.name !== 'idInsumo' && <RenderInputByTypeMobile
              key={`${index}-${input.name}`}
              grided
              handleChange={handleChange}
              input={input}
              value={indicacionesBAP[input.name]} />

          }
          {
            input.name === 'idInsumo' && <>
              <Grid sx={{ marginTop: 2.5 }} size={{ xs: 12 }}>
                <Autocomplete
                  options={insumos}
                  disabled={input.disabled}
                  key={indicacionesBAP?.idInsumo}
                  value={nombreInsumoSelected}
                  disableClearable
                  noOptionsText={filterStatus ? 'No hay coincidencias' : 'Escriba para buscar'}
                  onChange={(_, newValue) => handleSelectInsumo(newValue)}
                  renderOption={(props, option) => {
                    return (
                      <Box {...props} key={option.id}>
                        {option?.label}
                      </Box>);

                  }}
                  renderInput={(params) => <TextField
                    {...params}
                    onChange={(e) => setFilterStatus(e.target.value)}
                    sx={{ '.MuiOutlinedInput-root': { paddingRight: '15px !important' } }}
                    label={`${input.displayName}${input.required ? '*' : ''}`}
                    margin='none'
                    size='small'
                    inputProps={{
                      ...params.inputProps,
                      value: !!indicacionesBAP?.idInsumo || !!filterStatus ? params.inputProps.value : ''
                    }}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment:
                        <InputAdornment position='end'>
                          {insumosLoading ?
                            <CircularProgress color='inherit' size={20} /> :
                            <SearchIcon className='search-icon' />}
                        </InputAdornment>

                    }} />

                  } />

              </Grid>
            </>
          }
        </>;
      }
      )}
      <CustomButton
        sx={{ marginTop: '10px' }}
        isLoading={indicacionLoading}
        disabled={readOnly}
        className='margin-right'
        variant="outlined"
        onClick={() => onSubmit()}>

        Guardar Esquemas
      </CustomButton>
    </Grid>);

};

const useGetInsumos = (idInsumo, nombreInsumo, idEvaluacion) => {

  const [insumos, setInsumos] = useState([]);

  const [filterStatus, setFilterStatus] = useState('');
  const [nombreInsumoSelected, setNombreInsumoSelected] = useState('');
  const debouncedFilterValue = useDebounce(filterStatus, 1000);

  const [getInsumos, { loading: insumosLoading, data: dataInsumosValidate }] = useLazyQuery(GET_INSUMOS_VALIDATE_RI);

  useEffect(() => {
    if (!dataInsumosValidate) return;

    setInsumos(dataInsumosValidate);
  }, [dataInsumosValidate]);

  useEffect(() => {
    if (!nombreInsumo) return;
    setFilterStatus(nombreInsumo);
    setNombreInsumoSelected(nombreInsumo);
  }, [nombreInsumo]);

  useEffect(() => {
    if (!insumosLoading && !!debouncedFilterValue?.trim()) {
      getInsumos({
        variables: {
          idEvaluacion: idEvaluacion,
          where: { descripcion: { contains: debouncedFilterValue } }
        }
      });
    }
  }, [debouncedFilterValue]);

  return [
    adaptInsumosArray(insumos) || [],
    nombreInsumoSelected,
    filterStatus,
    insumosLoading,
    setFilterStatus,
    setNombreInsumoSelected];


};

const inputs = [
  {
    displayName: 'BAP Magistral',
    name: 'magistral',
    type: 'boolean',
    required: true
  },
  {
    displayName: 'Volumen',
    name: 'volumenMagistral',
    type: 'float',
    min: 0,
    max: 4000,
    required: false
  },
  {
    displayName: 'Conexiones por semana',
    name: 'diasConexionSemanaMagistral',
    type: 'checkbox',
    options: [
      { value: 1, label: 'L' },
      { value: 2, label: 'M' },
      { value: 3, label: 'X' },
      { value: 4, label: 'J' },
      { value: 5, label: 'V' },
      { value: 6, label: 'S' },
      { value: 7, label: 'D' }],

    selectAllOption: true,
    required: false
  },
  {
    displayName: 'BAP Estándar',
    name: 'bAPestandar',
    type: 'boolean',
    required: true
  },
  {
    displayName: '¿Cuál?',
    name: 'idInsumo',
    type: 'search',
    required: true
  },
  {
    displayName: 'Cantidad diaria',
    name: 'cantidadDiaria',
    type: 'int',
    min: 0,
    max: 2,
    required: false
  },
  {
    displayName: 'Conexiones por semana',
    name: 'diasConexionSemana',
    type: 'checkbox',
    options: [
      { value: 1, label: 'L' },
      { value: 2, label: 'M' },
      { value: 3, label: 'X' },
      { value: 4, label: 'J' },
      { value: 5, label: 'V' },
      { value: 6, label: 'S' },
      { value: 7, label: 'D' }],

    selectAllOption: true,
    required: true
  },
  {
    displayName: 'Modo de infusión',
    name: 'idComboRIValorModoInfusion',
    comboName: 'Modo de infusión AP',
    type: 'select',
    required: true
  },
  {
    displayName: 'Sellado de catéter',
    name: 'idComboRIValorSelladoCateter',
    comboName: 'Sellado de catéter AP',
    type: 'select',
    required: true
  }];